import React, { useContext } from "react";
import moment from "moment";
import classnames from "classnames";
import { useAccount } from "../../../../Hooks/EntityHooks";
import { AccountProfileImg } from "../../../Img/Img";

const HistoryItemContext = React.createContext();

export const useHistoryItem = () => {
  return useContext(HistoryItemContext);
};

export const HistoryTitle = ({ Icon, children, className }) => {
  return (
    <div className={classnames("d-flex align-items-center", className)}>
      <div className="ar-history-item-header-icon">
        <Icon />
      </div>
      <div className="lh-normal fs-14">{children}</div>
    </div>
  );
};

export const HistoryHeader = ({ children }) => {
  const { Date } = useHistoryItem();

  const d = moment(Date).format("DD/MM/YYYY HH:mm");
  return (
    <div className="d-flex align-items-center justify-content-between">
      {children}
      <div className="fs-12 ml-2 flex-0-0-auto">{d}</div>
    </div>
  );
};

export const HistoryOverview = ({ children }) => {
  return <div className="fs-14 text-black">{children}</div>;
};

export const HistoryContent = ({ children }) => {
  return <div className="ar-history-item-content">{children}</div>;
};

export const HistoryAccountProfile = ({ account }) => {
  const a = useAccount(account);
  return (
    <div className={"d-inline-block"}>
      <AccountProfileImg
        size="sm"
        account={a}
        circular
        className="d-inline-flex mr-0"
      />
      <b className="d-inline-block">&nbsp; {a.Name}</b>
    </div>
  );
};

export const HistoryItemProvider = ({ children, value }) => {
  return (
    <HistoryItemContext.Provider value={value}>
      {children}
    </HistoryItemContext.Provider>
  );
};
